import { message } from "antd";
import React, { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuthStore } from "../store";
import { parseError } from "../utils/parseError";
import { VERIFY_OTP } from "../graphql/Mutations";
import { OTPView } from "../components/secondary";
import { HeadingOne } from "../components/typography";
import AuthForm from "../components/forms/AuthForm";
import AuthPageShell from "../components/forms/AuthPageShell";
import BlueButton from "../components/buttons/BlueButton";
import { useRespondAuthChallegeVariables, useRespondAuthChallenge, useVerificationOTP } from "../hooks";
import SupportBlock from "../components/info/SupportBlock";
import mixpanelService from "../services/mixpanel";
import bugfenderHelper from "../services/bugfender";

const VerificationStepOne = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { OTP, handleSetOTP } = useVerificationOTP();

  const [verifyOTPMutation, {
    loading: verifyOTPLoading,
    data: verifyOTPData,
    error: verifyOTPError
  }] = useMutation(VERIFY_OTP);

  const {
    verificationCodeDestination,
    session,
    username
  } = useRespondAuthChallegeVariables();

  const loginFormInputs = useAuthStore((s) => s.loginInputs);

  const isVerifyPhoneNumber = location.state?.isVerifyPhoneNumber;
  const accessToken = location.state?.accessToken;
  const userData = location.state?.userData;

  const { handleOTP, respondeAuthLoading } = useRespondAuthChallenge({
    variables: {
      smsMfaCode: OTP,
      username,
      session,
      email: loginFormInputs.email || loginFormInputs.username,
      password: loginFormInputs.password
    },
    onCompletedCallback: (data) => {
      navigate(`/login-redirect/tripplo-mobile-auth/${data}`);
    }
  });

  const handleVerifyPhoneNumberOTP = () => {
    verifyOTPMutation({
      variables: {
        accessToken,
        attributeName: "phone_number",
        code: OTP
      }
    });
  }

  useEffect(() => {
    if (!verifyOTPData) return;

    if (verifyOTPData?.verifyOTP?.Error) {
      message.error(verifyOTPData.verifyOTP.Error.message);
      return;
    }

    message.success("Phone number has been verified!")
    navigate(`/login-redirect/tripplo-mobile-auth/${userData}`);

    mixpanelService.track("App.Verify.Mobile", {
      userData,
      device: "mobile"
    });
  }, [verifyOTPData]);

  useEffect(() => {
    if (!verifyOTPError) return;

    const errorMessage = parseError(verifyOTPError);
    bugfenderHelper.error(errorMessage);
    message.error(errorMessage);

  }, [verifyOTPError]);

  return (
    <AuthPageShell>
      <AuthForm>
        <HeadingOne className="text-[#003eb2] text-center text-2xl font-semibold mb-6">
          Verification step
        </HeadingOne>
        <OTPView
          OTP={OTP}
          disabled={respondeAuthLoading}
          verificationCodeDestination={verificationCodeDestination}
          handleSetOTP={handleSetOTP}
          verifyPhoneNumber={isVerifyPhoneNumber}
        />
        <BlueButton
          className="w-full mt-4 py-2.5 font-semibold hover:text-white"
          onClick={() => {
            isVerifyPhoneNumber ? handleVerifyPhoneNumberOTP() : handleOTP()
          }}
          isLoading={respondeAuthLoading || verifyOTPLoading}
          disabled={respondeAuthLoading || OTP.length !== 6}
        >
          Continue
        </BlueButton>
        <div className="auth-footer-rule" />
        <SupportBlock area="verify-step-one" tailwindProps="mt-0" />
      </AuthForm>
    </AuthPageShell>
  )
}

export default VerificationStepOne
